//* Importing the custom component
import { Attention } from "../../../component/base/Attention";
import PasswordInput from "../../../component/base/PasswordInput";
import DefaultButton from "../../../component/base/DefaultButton";

//* Importing components from react-bootstrap
import { Form, InputGroup } from "react-bootstrap";

//* Importing the images
import BgVestibular from "../../../assets/images/bg_vestibular.jpeg";
import Logo from "../../../assets/images/logo-ontest.png";

//* Importing the react hooks
import { useState, useEffect } from "react";

//* Importing the react-redux hooks
import { useDispatch, useSelector } from "react-redux";

//* Importing the moment
import moment from "moment";

//* Importing hooks from react-router-dom
import { Link, useNavigate } from "react-router-dom";

//* Importing the AuthAPI service
import { AuthAPI } from "../../../services/apis/AuthAPI";

//* Importing the action setTokenAndMe
import { setTokenAndMe } from "../../../services/stores/auth/actions";


/**
 * Validates a password based on the following criteria:
 * - Minimum length of 8 characters
 * - At least one uppercase letter
 * - At least one number
 * - At least one special symbol (e.g., !@#$%^&*(),.?":{}|<>_-)
 *
 * @param password - The password string to validate.
 * @returns An array of error messages if the password does not meet the criteria, otherwise an empty array.
 */
function validatePassword(password: string): string[] {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push("Mínimo de 8 caracteres");
  }
  if (!/[A-Z]/.test(password)) {
    errors.push("Pelo menos 1 letra maiúscula");
  }
  if (!/\d/.test(password)) {
    errors.push("Pelo menos 1 número");
  }
  if (!/[!@#$%^&*(),.?":{}|<>_\-]/.test(password)) {
    errors.push("Pelo menos 1 símbolo especial");
  }

  return errors;
}


export function ChangePasswordFirstLoginView() {
  const [password, setPassword] = useState<string>("");
  const [passwordConfirmation, setPasswordConfirmation] = useState<string>("");
  const [passwordErrors, setPasswordErrors] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const { token, me } = useSelector((store: any) => store.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //* Validates the password when the password changes
  useEffect(() => {
    if (password) {
      setPasswordErrors(validatePassword(password));
    } else {
      setPasswordErrors([]);
    }
  }, [password]);

  //* Function to handle the password change
  const handleChangePassword = async () => {
    setLoading(true);
    setErrorMessage("");

    if (passwordErrors.length > 0) {
      setErrorMessage("A senha não atende aos requisitos.");
      setLoading(false);
      return;
    }
    if (password !== passwordConfirmation) {
      setErrorMessage("As senhas não conferem.");
      setLoading(false);
      return;
    }

    //! Sends the password to the server
    try {
      const response = await AuthAPI.changePasswordFirstLogin(
        `Bearer ${token}`,
        password
      );

      if (response.result) {
        // Updates the user data in the Redux store
        dispatch(
          setTokenAndMe({
            me: { ...me, isPasswordDefinitive: true },
            token,
          })
        );
        navigate("/"); 
      } else {
        setErrorMessage(response.message || "Não foi possível mudar a senha.");
      }
    } catch (error) {
      console.error("Erro ao enviar a senha:", error);
      setErrorMessage("Ocorreu um erro ao definir a senha.");
    } finally {
      setLoading(false);
    }
  };

  //! Function to skip the password change
  const handleSkip = () => {
    dispatch(
      setTokenAndMe({
        me: { ...me, skipPasswordChange: true },
        token,
      })
    );
    navigate("/");
  };

  return (
    <div style={{ height: "100vh" }}>
      <div className="row" style={{ backgroundColor: "white", margin: 0 }}>
        <div
          className="col-md-6 col-12 col-sm-12 col-lg-4 col-xl-4"
          style={{ margin: 0, padding: 0 }}
        >
          <div className="card" style={{ height: "100vh", margin: 0 }}>
            <div
              className="card-body"
              style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
            >
              <br />
              <div className="text-center">
                <a className="logo">
                  <img
                    style={{ maxHeight: 70,objectFit:'contain' }}
                    src={Logo}
                    height="60"
                    alt="logo"
                  />
                </a>
              </div>
              <br />

              <div style={{ padding: "1rem", paddingBottom: 0, marginTop: 10 }}>
                <h4
                  className="font-18 m-b-5 text-center header-title"
                  style={{ fontSize: 18 }}
                >
                  Defina sua senha
                </h4>
                <p className="text-muted text-center" style={{ fontSize: 14 }}>
                  Você pode pular se quiser definir depois.
                </p>

                <form
                  className="form-horizontal m-t-30"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleChangePassword();
                  }}
                >
                  <InputGroup>
                    <div className="flex fdcolumn flex1 margin-bottom">
                      <Form.Label>
                        Nova Senha <Attention />
                      </Form.Label>
                      <PasswordInput
                        placeholder="Digite sua nova senha"
                        className="flex1"
                        value={password}
                        OnChangeText={(e: any) => setPassword(e.target.value)}
                      />
                    </div>
                  </InputGroup>

                  {passwordErrors.length > 0 && (
                    <ul style={{ marginLeft: "20px", color: "red" }}>
                      {passwordErrors.map((err, index) => (
                        <li key={index} style={{ fontSize: "0.9rem" }}>
                          {err}
                        </li>
                      ))}
                    </ul>
                  )}

                  <InputGroup style={{ marginTop: "1rem" }}>
                    <div className="flex fdcolumn flex1 margin-bottom">
                      <Form.Label>
                        Confirmar Senha <Attention />
                      </Form.Label>
                      <PasswordInput
                        placeholder="Confirme sua nova senha"
                        className="flex1"
                        value={passwordConfirmation}
                        OnChangeText={(e: any) =>
                          setPasswordConfirmation(e.target.value)
                        }
                        
                      />
                    </div>
                  </InputGroup>


                  <div className="form-group row m-t-20 m-b-10">
                    <div className="col-sm-12">
                      {errorMessage && (
                        <span
                          className="invalid-feedback"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                          role="alert"
                        >
                          <strong
                            style={{
                              textAlign: "center",
                              fontSize: "0.8rem",
                            }}
                          >
                            {errorMessage}
                          </strong>
                        </span>
                      )}
                    </div>
                    <div className="col-sm-12 text-right">
                      <DefaultButton
                        type="submit"
                        bg="primary"
                        width="100%"
                        height="3rem"
                        style={{ marginTop: "15px" }}
                        text="Salvar"
                        loadingtext="Salvando..."
                        loading={loading}
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div className="text-center" style={{ marginTop: 20 }}>
                <p style={{ fontSize: 14 }}>
                  © {moment().format("YYYY")} Allan
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-6 col-sm-6 col-12 col-lg-8 col-xl-8 d-none d-md-block"
          style={{
            overflow: "hidden",
            backgroundImage: `url(${BgVestibular})`,
            backgroundSize: "cover",
            padding: 0,
            margin: 0,
            height: "100vh",
          }}
        ></div>
      </div>
    </div>
  );
}
